import { reduxRequest } from "common/utils/reduxRequest";
import { makeFilterString } from "../utils/Helper";
import { GetDashboardDataSuccess, DashboardLoading, GetBestSellingProductsSuccess, GetSalesReportSuccess, GetSoldQuantitiesReportSuccess, GetVatReportSuccess } from "./Action";

export const getDashboardDataRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DashboardLoading,
    loadingType: "dashboard",
    successFunction: GetDashboardDataSuccess,
    url: `/admin/dashboard${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getBestSellingProductsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DashboardLoading,
    loadingType: "dashboard",
    successFunction: GetBestSellingProductsSuccess,
    url: `/admin/dashboard/best_selling_products${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getSalesReportRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DashboardLoading,
    loadingType: "dashboard",
    successFunction: GetSalesReportSuccess,
    url: `/admin/dashboard/sales_report${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getSoldQuantitiesReportRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DashboardLoading,
    loadingType: "dashboard",
    successFunction: GetSoldQuantitiesReportSuccess,
    url: `/admin/dashboard/sold_quantities_report${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getVatReportRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DashboardLoading,
    loadingType: "dashboard",
    successFunction: GetVatReportSuccess,
    url: `/admin/dashboard/vat_report${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
